import { ThemeProvider } from "@mui/material/styles"
import { createTheme } from "@mui/material"
import LayoutRouter from "./router/layoutRouter"
import { colors } from "./utils"
import "./css/styles.css"

const App = () => {
	const theme = createTheme({
		palette: {
			success: {
				main: colors.green,
			},
		},
		breakpoints: {
			values: {
				xs: 425,
				sm: 600,
				md: 768,
				lg: 992,
				xl: 1200,
				xxl: 1500,
			},
		},
	})
	return (
		<ThemeProvider theme={theme}>
			<LayoutRouter />
		</ThemeProvider>
	)
}

export default App
